import { useEffect, useMemo, useState } from 'react';
import {
  GRID_GAP_PX,
  GRID_GAP_PX_MD,
  GRID_HORIZONTAL_PADDING_PX,
  GRID_HORIZONTAL_PADDING_PX_MOBILE,
  GRID_IMAGES_PER_ROW_MOBILE,
  GRID_SECTION_WIDTH_RATIO,
  GRID_SECTION_WIDTH_RATIO_MOBILE,
  TILE_ASPECT_RATIO,
  buildViewportGridTiles,
  getDesktopColumnCount,
} from '../portfolioGridData';

export function useViewportGridTiles(isMobile) {
  const [viewport, setViewport] = useState(() => ({
    width: typeof window !== 'undefined' ? window.innerWidth : 1280,
    height: typeof window !== 'undefined' ? window.innerHeight : 800,
  }));

  useEffect(() => {
    const update = () => {
      setViewport({ width: window.innerWidth, height: window.innerHeight });
    };

    update();
    window.addEventListener('resize', update);

    return () => window.removeEventListener('resize', update);
  }, []);

  return useMemo(() => {
    const gap = isMobile ? GRID_GAP_PX : GRID_GAP_PX_MD;
    const padding = isMobile ? GRID_HORIZONTAL_PADDING_PX_MOBILE : GRID_HORIZONTAL_PADDING_PX;
    const sectionWidthRatio = isMobile ? GRID_SECTION_WIDTH_RATIO_MOBILE : GRID_SECTION_WIDTH_RATIO;
    const gridWidth = viewport.width * sectionWidthRatio;
    const innerWidth = gridWidth - padding * 2;
    const aspectParts = TILE_ASPECT_RATIO.split('/').map((part) => Number(part.trim()));
    const aspectRatio = aspectParts[0] / aspectParts[1];
    const cols = isMobile
      ? GRID_IMAGES_PER_ROW_MOBILE
      : getDesktopColumnCount(innerWidth, gap);
    const tileWidth = Math.max(28, (innerWidth - (cols - 1) * gap) / cols);
    const tileHeight = tileWidth / aspectRatio;
    const rowCount = Math.max(
      3,
      Math.floor((viewport.height - padding * 2 + gap) / (tileHeight + gap))
    );
    const tiles = buildViewportGridTiles(cols * rowCount);
    const gridOffsetX = (viewport.width - innerWidth) / 2;

    return {
      cols,
      rowCount,
      tileWidth,
      tileHeight,
      gap,
      padding,
      gridOffsetX,
      tiles,
    };
  }, [isMobile, viewport.height, viewport.width]);
}
